import React, { useEffect, useState } from 'react';
import lostGif from 'assets/images/lost.gif';
import logo from 'assets/images/logo.jpg';
import { Link } from 'react-router-dom';
import { ROUTES } from '@lsgo/lsgo-common/constants/routes';
import posthog from 'posthog-js';
import { clearWebCachesAndReload, isChunkLoadError } from 'utils/chunkLoadError';

function errorToAnalyticsString(value) {
    if (value instanceof Error) {
        return JSON.stringify({
            name: value.name,
            message: value.message,
            stack: value.stack,
        });
    }
    if (value !== null && typeof value === 'object') {
        try {
            return JSON.stringify(value);
        } catch {
            return String(value);
        }
    }
    return String(value);
}

export default function Page404({ error }) {
    const [reloadBusy, setReloadBusy] = useState(false);
    const chunkLoadError = isChunkLoadError(error);

    useEffect(() => {
        if (!error) return;

        try {
            const href = window.location && window.location.href ? window.location.href : 'unknown';

            posthog.capture('page_404_error_rendered', {
                surface: 'teacher',
                href,
                pathname: window.location && window.location.pathname,
                search: window.location && window.location.search,
                referrer: document && document.referrer,
                error: errorToAnalyticsString(error),
                chunk_load_error: isChunkLoadError(error),
            });
        } catch (e) {
            console.log('error', e);
        }
    }, [error]);

    const onHardReload = () => {
        setReloadBusy(true);
        void clearWebCachesAndReload();
    };

    return (
        <div
            style={{
                width: '100%',
                height: '100vh',
                background: '#ccc url(' + lostGif + ') no-repeat center bottom',
                backgroundSize: 'cover',
                display: 'flex',
                alignItems: 'center',
                alignContent: 'center',
            }}
        >
            <div
                style={{
                    width: '100%',
                    maxWidth: '500px',
                    margin: '0 auto',
                    padding: 80,
                    backgroundColor: 'rgba(204,204,204,0.8)',
                    textAlign: 'center',
                    borderRadius: 4,
                }}
            >
                <div>
                    <img src={logo} style={{ maxHeight: '140px' }} />
                </div>
                {!error ? (
                    <h3>
                        It seems like you are lost. Go back to <Link to={ROUTES.TEACHER.DASHBOARD.path}>Dashboard</Link>
                    </h3>
                ) : chunkLoadError ? (
                    <>
                        <h3 style={{ marginBottom: 16 }}>This page needs a fresh reload</h3>
                        <p style={{ marginBottom: 12, lineHeight: 1.5 }}>
                            A piece of the site didn&apos;t load—usually after an update or when the browser cache is
                            stuck. This isn&apos;t a problem with your account.
                        </p>
                        <div style={{ marginTop: 8, marginBottom: 16 }}>
                            <button
                                type="button"
                                disabled={reloadBusy}
                                onClick={onHardReload}
                                style={{
                                    padding: '12px 20px',
                                    fontSize: 16,
                                    cursor: reloadBusy ? 'wait' : 'pointer',
                                    backgroundColor: '#1976d2',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: 4,
                                    fontWeight: 600,
                                }}
                            >
                                {reloadBusy ? 'Reloading…' : 'Reload site (clear cache)'}
                            </button>
                        </div>
                        <p style={{ marginBottom: 0, fontSize: 14, opacity: 0.85 }}>
                            Or go to{' '}
                            <Link to={ROUTES.TEACHER.DASHBOARD.path} style={{ fontWeight: 600 }}>
                                Dashboard
                            </Link>
                            .
                        </p>
                    </>
                ) : (
                    <h3>
                        Oops. There was an error. Go back to <Link to={ROUTES.TEACHER.DASHBOARD.path}>Dashboard</Link>.
                    </h3>
                )}
            </div>
        </div>
    );
}
